import React from 'react';

import { useTranslation } from 'react-i18next';

import { refreshPage } from 'helpers/utils';
import ErrorMessageIcon from 'styles/assets/bellAlerts/notificationErrorMessage.png';

import styles from './errorMessage.module.scss';

const ErrorMessage = () => {
  const { t } = useTranslation(['errors', 'common']);

  return (
    (<div className={styles.mainContainer} data-palette="ErrorMessage">
      <div className={styles.contentBox}>
        <img src={ErrorMessageIcon} alt={t('errors:utils.somethingWentWrong')} />
        <div className={styles.text}>
          {t('errors:utils.somethingWentWrong')}
          {t('errors:utils.pleaseTryAgain')}
        </div>
      </div>
      <button
        type="button"
        data-testid="error-message-reload-button"
        className={styles.reloadButton}
        onClick={refreshPage}
      >
        {t('common:reloadPage')}
      </button>
    </div>)
  );
};

export default ErrorMessage;
